import {Pipe, PipeTransform} from '@angular/core';
import {Location} from '../domain/location/location';

@Pipe({
    name: 'location',
    pure: false
})
export class LocationPipe implements PipeTransform {
    transform(location: Location, locationType: LocationType = LocationType.ALL): string {
        if (!location) {
            return '';
        }

        const address: Array<string> = [];

        if (locationType === LocationType.ALL || locationType === LocationType.ROUTE) {
            if (location.streetNumber) {
                address.push(location.streetNumber);
            }
            if (location.route) {
                address.push(location.route);
            }
        }

        if (locationType === LocationType.ALL || locationType === LocationType.EXTRA) {
            if (location.extra) {
                address.push(location.extra);
            }
        }

        if (locationType === LocationType.ALL || locationType === LocationType.CITY) {
            if (location.postalCode) {
                address.push(location.postalCode);
            }
            if (location.city) {
                address.push(location.city);
            }
        }

        if (locationType === LocationType.ALL || locationType === LocationType.COUNTRY) {
            if (location.country) {
                address.push(location.country);
            }
        }

        return address.join(' ');
    }
}

export enum LocationType {
    ALL = 'ALL',
    ROUTE = 'ROUTE',
    EXTRA = 'EXTRA',
    CITY = 'CITY',
    COUNTRY = 'COUNTRY'
}
